import React from "react";
import styles from "./index.module.scss";

export interface PollRadioProps {
  /** Option label (e.g. "Çok Kısa") */
  label: string;
  /** Name shared by all options in the group */
  name: string;
  /** Value for this option */
  value: string;
  /** Whether this option is selected */
  checked: boolean;
  /** Called when this option is selected (passes value) */
  onChange: (value: string) => void;
  /** Disable the option */
  disabled?: boolean;
  /** Optional id for the input (for accessibility) */
  id?: string;
  /** Optional className for the root container */
  className?: string;
}

export const PollRadio: React.FC<PollRadioProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  disabled = false,
  id,
  className,
}) => {
  const inputId =
    id ?? `poll-radio-${name}-${value.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <label
      className={`${styles.root} ${disabled ? styles.root_disabled : ""} ${className ?? ""}`}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(value)}
        className={styles.input}
        aria-checked={checked}
      />
      <span className={styles.boxWrap}>
        <span className={styles.box} />
      </span>
      <span className={styles.answer}>
        <span className={styles.label}>{label}</span>
      </span>
    </label>
  );
};

export default PollRadio;
